import { render, staticRenderFns } from "./BalanceVanTab.vue?vue&type=template&id=5822e3b4&scoped=true"
import script from "./BalanceVanTab.vue?vue&type=script&lang=js"
export * from "./BalanceVanTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceVanTab.vue?vue&type=style&index=0&id=5822e3b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822e3b4",
  null
  
)

export default component.exports